
export default {
    namespaced: true,
    state: () => ({
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : ['recdate'],
            sortDesc : [true],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        search: null,
        category: 'OnRegistration',
        statuses: [
            { category: "OnRegistration", value: "All" },
            { category: "Registered", value: "All" },
            { category: "Completed", value: "All" }
        ],
        years: [
            { status: "All", value: "0"},
            { status: "Refusal", value: "0"},
            { status: "PositiveResponse", value: "0"},
        ],
        extendedFilter: {
            WithComments:
            {
                label: "Tолько_с_комментариями",
                value: null
            },
            CreateDateFrom:
            {
                label: "Дата_создания_с",
                value: null
            },
            CreateDateTo:
            {
                label: "Дата_создания_по",
                value: null
            },
            RegDateFrom:
            {
                label: "Дата_регистрации_с",
                value: null
            },
            RegDateTo:
            {
                label: "Дата_регистрации_по",
                value: null
            },
            DeclarantType:
            {
                label: "Категория_лица",
                value: null
            },
            ExecDateFrom:
            {
                label: "Дата_исполнения_с",
                value: null
            },
            ExecDateTo:
            {
                label: "Дата_исполнения_по",
                value: null
            },
            ExecuterWorkplaceId:
            {
                label: "Исполнитель",
                value: null
            },
            RegistratorWorkplaceId:
            {
                label: "Регистратор",
                value: null
            },
            CameFrom:
            {
                label: "Поступило_из",
                value: null
            }
        }
    }),
    mutations: {
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
        SET_SEARCH (state, payload) {
            state.search = payload;
        },
        SET_CATEGORY (state, payload) {
            state.category = payload;

            switch(state.category)
            {
                case 'OnRegistration':
                    state.tableOptions.sortBy = ['recdate'];
                    state.tableOptions.sortDesc = [true];
                    break;
                case 'Registered':
                    state.tableOptions.sortBy = ['regdate'];
                    state.tableOptions.sortDesc = [true];
                    break;
                case 'Completed':
                    state.tableOptions.sortBy = ['execdate'];
                    state.tableOptions.sortDesc = [true];
                    break;

            }
        },
        PUSH_STATUS (state, payload) { 
            let status = state.statuses.find(x => x.category == state.category);

            if (status)
                status.value = payload;
        },
        PUSH_YEAR (state, payload) { 
            let status = state.statuses.find(x => x.category == state.category);

            if (status) {
                let year = state.years.find(x => x.status == status.value);

                if (year)
                    year.value = payload;
            }
        },
        SET_EXTENDED_FILTER (state, payload) {
            state.extendedFilter = payload;
        },
    },
    getters: {
        getTableOptions: (s) => s.tableOptions,
        getExtendedFilter: (s) => s.extendedFilter,
        getSearch: (s) => s.search,
        getCategory: (s) => s.category,
        getStatus: (s) => s.statuses.find(x => x.category == s.category)?.value,
        getYear: (s, g) => s.years.find(x => x.status == g.getStatus)?.value,
    }
}